import { useState, useEffect } from "react";
import Card from "./Card";
import "./CardSlot.css";

const INTERVALS = [160, 160, 160, 160, 300, 300, 300, 500, 700];

const CardPair = ({ pair, isTrump, decidedSlot, animKey }) => {
  const [activeSlot, setActiveSlot] = useState(null);
  const [settled, setSettled] = useState(false);

  useEffect(() => {
    if (decidedSlot === null || decidedSlot === undefined) {
      setActiveSlot(null);
      setSettled(false);
      return;
    }

    setSettled(false);
    let current = 0;
    const timeouts = [];

    const runStep = (index) => {
      if (index >= INTERVALS.length) {
        setActiveSlot(decidedSlot);
        setSettled(true);
        return;
      }
      const t = setTimeout(() => {
        current = 1 - current;
        setActiveSlot(current);
        runStep(index + 1);
      }, INTERVALS[index]);
      timeouts.push(t);
    };

    runStep(0);
    return () => timeouts.forEach(clearTimeout);
  }, [animKey]);

  const hideCard      = settled && decidedSlot === 1;  
  const hideSuperCard = settled && decidedSlot === 0; 

  return (
    <div className="pair">
      <div className={`cardWrapper 
        ${activeSlot === 0 && !settled ? "slot-active" : ""} 
        ${settled && decidedSlot === 0 ? "slot-settled" : ""} 
        ${hideCard ? "slot-hidden" : ""}`}>
        <Card cardName={pair.card} isTrump={isTrump} />
      </div>
      <div className={`cardWrapper 
        ${activeSlot === 1 && !settled ? "slot-active" : ""} 
        ${settled && decidedSlot === 1 ? "slot-settled" : ""} 
        ${hideSuperCard ? "slot-hidden" : ""}`}>
        <Card cardName={pair.superCard} isTrump={isTrump} />
      </div>
    </div>
  );
};

const GhostCardPair = ({ pair }) => (
  <div className="pair cardPreviewGhost">
    <div className="cardWrapper">
      {pair.card && <Card cardName={pair.card} />}
    </div>
    <div className="cardWrapper">
      {pair.superCard && <Card cardName={pair.superCard} />}
    </div>
  </div>
);


const CardSlot = ({ pairs, isTrump, showSuperSlots, decidedSlot, animKey, previewPair }) => {
  const ghostIndex = pairs.length;
  const showGhost = previewPair && (previewPair.card || previewPair.superCard);

  return (
    <div className="pairStack">
      {pairs.map((pair, i) => (
        <div key={i} className="pairLayer" style={{ transform: `translate(${i * 20}px, ${-i * 20}px)`, zIndex: i + 1 }}>
          <CardPair pair={pair} isTrump={isTrump} decidedSlot={decidedSlot} animKey={animKey} />
        </div>
      ))}

      {showGhost && (
        <div className="pairLayer" style={{ transform: `translate(${ghostIndex * 20}px, ${-ghostIndex * 20}px)`, zIndex: ghostIndex + 1 }}>
          <GhostCardPair pair={previewPair} />
        </div>
      )}
    </div>
  );
};

export default CardSlot;